import React, { useState } from 'react'
import { AccountsLayout } from './components/layout'
import { OffliceList } from './components/OffliceList'
import { Button } from 'cwp-components/forms'
import { AddNewOfficeModal } from './components/AddNewOfficeModal'

const ProfileOfficeList = () => {
  const [selectedList, setSelectedList] = useState<any>([])
  const [openModal, setOpenModal] = useState<boolean>(false)

  const onAddNewOffice = () => {
    setOpenModal(!openModal)
  }

  return (
    <>
      <AccountsLayout>
        <div className='md:p-[60px] md:w-[900px] w-full  p-[20px] md:mx-auto bg-white rounded-[20px]'>
          <h1 className='mb-[32px] md:text-[24px] text-[16px] font-bold '>
            Profile creation
          </h1>
          <p className='mb-[24px] text-[#0C5F71] md:text-[18px] text-[14px]  font-bold '>
            Select the office that you work from
          </p>

          <div
            className='space-y-[15px] pr-2 h-[580px] scroll-px-3	 appearance-none overflow-y-auto overflow-x-hidden
            [&::-webkit-scrollbar]:w-[7px]
            [&::-webkit-scrollbar-*]:!h-[50px]
            [&::-webkit-scrollbar-track]:ml-[20px]
            [&::-webkit-scrollbar-thumb]:rounded-full
            [&::-webkit-scrollbar-track]:bg-white
            [&::-webkit-scrollbar-track]:!w-4
            [&::-webkit-scrollbar-thumb]:bg-[#001A3D]'
          >
            {[1, 2, 3, 4].map((data, idx) => (
              <OffliceList
                selected={selectedList}
                setSelected={setSelectedList}
                id={`label-${idx}`}
              />
            ))}
          </div>
          <p
            onClick={onAddNewOffice}
            className='m-[16px_0px_24px] flex items-center gap-[6px] text-[12px] cursor-pointer font-medium text-[#5858DF]'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='17'
              height='17'
              viewBox='0 0 17 17'
              fill='none'
            >
              <path
                d='M8.5 3.8335V13.1668'
                stroke='#5858DF'
                stroke-width='2.5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M3.83203 8.5H13.1654'
                stroke='#5858DF'
                stroke-width='2.5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Add new office
          </p>

          <div className='flex justify-end'>
            <Button
              className={`!text-[16px] ${
                selectedList.length > 0
                  ? '!bg-[#020251] !text-white'
                  : '!text-[#A0ABBE] !bg-[#F4F4F4]'
              }`}
            >
              Continue
            </Button>
          </div>
        </div>
        <AddNewOfficeModal open={openModal} setModal={setOpenModal} />
      </AccountsLayout>
    </>
  )
}

export default ProfileOfficeList
